export default __webpack_public_path__ + "static/media/hht1_ep12_minisitcom_04.c63a7d38.png";